'use strict'

const f = {
  isFunction: function (value) {
    return typeof value === 'function'
  }
}

module.exports = f
